import _, { functions } from 'lodash'
import React from 'react'
import WellImportData from './components/WellImportData'
import FileImport from './components/FileImport'
import ImportUtil from './util/ImportUtil'
import { convertRigBopFile } from './util/ConversionUtil'
import { RigImport } from './types/RigImport'
import { ConstantsImport } from './constants/ConstantsImport'
import { Sections } from './types/SectionCompletionTypes'

export function ImportControl({
    assets,
    onSelectFile: _onSelectFile,
    typeAsset,
    filterBy,
    checks,
    checkedItens,
    iconName,
    onCheck,
    setEnable,
    submited,
    setSubmited,
    extra
}: {
    assets: AssetsData
    onSelectFile: Function
    typeAsset: string
    filterBy?: string
    checks?: Array<{ key: string; description: string }>
    checkedItens?: Record<string, any>
    iconName?: string
    onCheck?: Function
    setEnable: Function
    onSaveImport: Function
    onCancelImport: Function
    submited: boolean
    setSubmited: Function
    onBack: Function
    extra: { drillingSections: Sections }
}): React.ReactNode {
    function onSelectFile(fileData) {
        const parsedSections = fileData?.sections?.sections.map((section, index) => ({
            ...section,
            casing_type: validateCasingType(section)
        }))

        const convertedFile = _.set(fileData, 'sections.sections', parsedSections)

        return _onSelectFile(convertedFile)
    }

    return (
        <div className="wellImport">
            <React.Fragment>
                {(typeAsset === 'well' || typeAsset === 'intervention') && (
                    <WellImportData
                        well={assets.well}
                        onSelectFile={onSelectFile}
                        checks={checks}
                        checkedItens={checkedItens}
                        onCheck={onCheck}
                        setEnable={setEnable}
                        submited={submited}
                        setSubmited={setSubmited}
                        typeAsset={typeAsset}
                        startTimestamp={extra?.startTimestamp}
                        typesListShow={ConstantsImport.wellInterventionFileTypes}
                        drillingSections={extra?.drillingSections}
                    />
                )}
                {typeAsset === 'rig' && (
                    <FileImport
                        onSelectFile={(file: RigImport) => {
                            onSelectFile(convertRigBopFile(file))
                        }}
                        fileType={ImportUtil.getFileType(typeAsset)}
                        filterBy={filterBy}
                        iconName={iconName}
                        setEnable={setEnable}
                    />
                )}
            </React.Fragment>
        </div>
    )
}

// eslint-disable-next-line camelcase
function validateCasingType(section: { runs: { type: string }[]; well_bores: { type: string }[] }): string {
    const keys = [
        { from: 'revestimento', to: 'casing' },
        { from: 'liner', to: 'liner' }
    ]
    const found = keys.find(item => {
        const casingName = section.well_bores?.[0]?.type?.toLowerCase()

        return casingName?.includes(item.from) || casingName?.includes(item.to)
    })

    if (found) {
        return found.to
    }

    return section.well_bores?.[0]?.type?.toLowerCase().trim()
}
